import {PlatformType} from "../shared/types/PlatformType.ts";

export const isMobileChecker = (platformType: PlatformType): Boolean => {
    return platformType === 'ios' || platformType === 'android'
}
